export const WALLPAPER_INPUT_OPTIONS = {
  multiple: false,
  accept: '.jpg,.jpeg,.png,image/png,image/jpeg',
};

export const SURVEY_URL = `https://we-transfer.typeform.com/to/W5adpi93`;
